import { StyleSheet } from "react-native";
import { AppColors } from "../utility/AppColors";

export const AppFontStyle = StyleSheet.create({
  LIGHT_ANYBODY_6: {
    fontFamily: "Anybody_300Light",
    fontSize: 6,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_8: {
    fontFamily: "Anybody_300Light",
    fontSize: 8,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_10: {
    fontFamily: "Anybody_300Light",
    fontSize: 10,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_12: {
    fontFamily: "Anybody_300Light",
    fontSize: 12,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_14: {
    fontFamily: "Anybody_300Light",
    fontSize: 14,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_16: {
    fontFamily: "Anybody_300Light",
    fontSize: 16,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_18: {
    fontFamily: "Anybody_300Light",
    fontSize: 18,
    color: AppColors.white,
  },
  LIGHT_ANYBODY_20: {
    fontFamily: "Anybody_300Light",
    fontSize: 20,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_6: {
    fontFamily: "Anybody_400Regular",
    fontSize: 6,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_8: {
    fontFamily: "Anybody_400Regular",
    fontSize: 8,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_10: {
    fontFamily: "Anybody_400Regular",
    fontSize: 10,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_11: {
    fontFamily: "Anybody_400Regular",
    fontSize: 11,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_12: {
    fontFamily: "Anybody_400Regular",
    fontSize: 12,
    color: AppColors.white,
  },

  REGULAR_ANYBODY_13: {
    fontFamily: "Anybody_400Regular",
    fontSize: 13,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_14: {
    fontFamily: "Anybody_400Regular",
    fontSize: 14,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_15: {
    fontFamily: "Anybody_400Regular",
    fontSize: 15,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_16: {
    fontFamily: "Anybody_400Regular",
    fontSize: 16,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_18: {
    fontFamily: "Anybody_400Regular",
    fontSize: 18,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_20: {
    fontFamily: "Anybody_400Regular",
    fontSize: 20,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_22: {
    fontFamily: "Anybody_400Regular",
    fontSize: 22,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_24: {
    fontFamily: "Anybody_400Regular",
    fontSize: 24,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_28: {
    fontFamily: "Anybody_400Regular",
    fontSize: 28,
    color: AppColors.white,
  },
  // REGULAR_ANYBODY_30: {
  //   fontFamily: "Anybody_800Regular",
  //   fontSize: 30,
  //   color: AppColors.white,
  // },
  REGULAR_ANYBODY_30: {
    fontFamily: "Anybody_800Regular",
    fontSize: 30,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_32: {
    fontFamily: "Anybody_400Regular",
    fontSize: 32,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_35: {
    fontFamily: "Anybody_400Regular",
    fontSize: 35,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_40: {
    fontFamily: "Anybody_700Regular",
    fontSize: 40,
    color: AppColors.white,
  },
  REGULAR_ANYBODY_48: {
    fontFamily: "Anybody_400Regular",
    fontSize: 48,
    color: AppColors.white,
  },

  MEDIUM_ANYBODY_6: {
    fontFamily: "Anybody_500Medium",
    fontSize: 6,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_8: {
    fontFamily: "Anybody_500Medium",
    fontSize: 8,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_10: {
    fontFamily: "Anybody_500Medium",
    fontSize: 10,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_12: {
    fontFamily: "Anybody_500Medium",
    fontSize: 12,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_14: {
    fontFamily: "Anybody_500Medium",
    fontSize: 14,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_16: {
    fontFamily: "Anybody_500Medium",
    fontSize: 16,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_18: {
    fontFamily: "Anybody_500Medium",
    fontSize: 18,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_20: {
    fontFamily: "Anybody_500Medium",
    fontSize: 20,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_22: {
    fontFamily: "Anybody_500Medium",
    fontSize: 22,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_24: {
    fontFamily: "Anybody_500Medium",
    fontSize: 24,
    color: AppColors.white,
  },
  MEDIUM_ANYBODY_28: {
    fontFamily: "Anybody_500Medium",
    fontSize: 28,
    color: AppColors.white,
  },

  SEMIBOLD_ANYBODY_6: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 6,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_8: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 8,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_10: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 10,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_12: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 12,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_14: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 14,
    color: AppColors.white,
  },
  BOLD_ANYBODY_15: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 15,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_16: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 16,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_18: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 18,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_20: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 20,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_22: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 22,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_24: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 24,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_26: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 26,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_28: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 28,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_38: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 38,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_41: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 41,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_84: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 84,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_74: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 74,
    color: AppColors.white,
  },
  SEMIBOLD_ANYBODY_60: {
    fontFamily: "Anybody_600SemiBold",
    fontSize: 60,
    color: AppColors.white,
  },
  BOLD_ANYBODY_6: {
    fontFamily: "Anybody_700Bold",
    fontSize: 6,
    color: AppColors.white,
  },
  BOLD_ANYBODY_8: {
    fontFamily: "Anybody_700Bold",
    fontSize: 8,
    color: AppColors.white,
  },
  BOLD_ANYBODY_10: {
    fontFamily: "Anybody_700Bold",
    fontSize: 10,
    color: AppColors.white,
  },
  BOLD_ANYBODY_11: {
    fontFamily: "Anybody_700Bold",
    fontSize: 11,
    color: AppColors.white,
  },
  BOLD_ANYBODY_12: {
    fontFamily: "Anybody_700Bold",
    fontSize: 12,
    color: AppColors.white,
  },
  BOLD_ANYBODY_14: {
    fontFamily: "Anybody_700Bold",
    fontSize: 14,
    color: AppColors.white,
  },
  BOLD_ANYBODY_16: {
    fontFamily: "Anybody_700Bold",
    fontSize: 16,
    color: AppColors.white,
  },
  BOLD_ANYBODY_17: {
    fontFamily: "Anybody_700Bold",
    fontSize: 17,
    color: AppColors.white,
  },
  BOLD_ANYBODY_18: {
    fontFamily: "Anybody_700Bold",
    fontSize: 18,
    color: AppColors.white,
  },
  BOLD_ANYBODY_20: {
    fontFamily: "Anybody_700Bold",
    fontSize: 20,
    color: AppColors.white,
  },
  BOLD_ANYBODY_21: {
    fontFamily: "Anybody_700Bold",
    fontSize: 21,
    color: AppColors.white,
  },
  BOLD_ANYBODY_22: {
    fontFamily: "Anybody_700Bold",
    fontSize: 22,
    color: AppColors.white,
  },
  BOLD_ANYBODY_23: {
    fontFamily: "Anybody_700Bold",
    fontSize: 23,
    color: AppColors.white,
  },
  BOLD_ANYBODY_24: {
    fontFamily: "Anybody_700Bold",
    fontSize: 24,
    color: AppColors.white,
  },
  BOLD_ANYBODY_25: {
    fontFamily: "Anybody_700Bold",
    fontSize: 25,
    color: AppColors.white,
  },
  BOLD_ANYBODY_26: {
    fontFamily: "Anybody_700Bold",
    fontSize: 26,
    color: AppColors.white,
  },
  BOLD_ANYBODY_27: {
    fontFamily: "Anybody_700Bold",
    fontSize: 27,
    color: AppColors.white,
  },
  BOLD_ANYBODY_28: {
    fontFamily: "Anybody_700Bold",
    fontSize: 28,
    color: AppColors.white,
  },
  BOLD_ANYBODY_32: {
    fontFamily: "Anybody_700Bold",
    fontSize: 32,
    color: AppColors.white,
  },
  BOLD_ANYBODY_36: {
    fontFamily: "Anybody_800Bold",
    fontSize: 36,
    color: AppColors.white,
  },
  BOLD_ANYBODY_40: {
    fontFamily: "Anybody_700Bold",
    fontSize: 40,
    color: AppColors.white,
  },
  BOLD_ANYBODY_44: {
    fontFamily: "Anybody_700Bold",
    fontSize: 44,
    color: AppColors.white,
  },
  BOLD_ANYBODY_48: {
    fontFamily: "Anybody_700Bold",
    fontSize: 48,
    color: AppColors.white,
  },
  BOLD_ANYBODY_60: {
    fontFamily: "Anybody_700Bold",
    fontSize: 60,
    color: AppColors.white,
  },
  BOLD_ITALIC_ANYBODY_12: {
    fontFamily: "Anybody_600SemiBold_Italic",
    fontSize: 12,
    color: AppColors.white,
  },
  MEDIUM_ITALIC_ANYBODY_12: {
    fontFamily: "Anybody_500Medium_Italic",
    fontSize: 12,
    color: AppColors.white,
  },
  REGULAR_ITALIC_ANYBODY_12: {
    fontFamily: "Anybody_400Regular_Italic",
    fontSize: 12,
    color: AppColors.white,
  },
  // Bebas Neue Font Styles
  REGULAR_BEBAS_NEUE_35: {
    fontFamily: "Bebas Neue",
    fontSize: 35.8,
    fontWeight: "400",
    color: AppColors.white,
    lineHeight: 41.349,
  },
  // Altis_500Medium_14: {
  //   fontFamily: "Altis_500Medium",
  //   fontWeight: 14
  //   ,
  // }
});
